"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.recursivelyUnset = exports.removeElementStyle = exports.clearWidgetOverrides = exports.clearMatchingOverrides = exports.updateWidgetStyles = exports.clearElementStyles = void 0;
var slate_1 = require("slate");
var slate_2 = require("slate");
var lodash_1 = require("lodash");
var Config_types_1 = require("@CommonFrontend/WidgetRegistry/CommonWidgets/Config.types");
var GetTraitConfig_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetTraitConfig");
var Styleable_1 = require("Project/QwilrEditor/WidgetRegistry/Utils/Styleable");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var clearElementStyles = function (editor, path) {
    var widgetEntry = slate_2.Editor.node(editor, path);
    if (!slate_1.Element.isElement(widgetEntry[0])) {
        return;
    }
    slate_1.Transforms.setNodes(editor, { style: {} }, { at: path, match: nodeSupportsStyles, mode: "highest" });
};
exports.clearElementStyles = clearElementStyles;
var nodeSupportsStyles = function (node) {
    return slate_1.Element.isElement(node) && "style" in node;
};
var updateWidgetStyles = function (editor, path, newStyles) {
    var e_1, _a;
    var widgetEntry = slate_2.Editor.node(editor, path);
    if (!slate_1.Element.isElement(widgetEntry[0])) {
        return;
    }
    var _b = __read(widgetEntry, 1), widget = _b[0];
    if (!nodeSupportsStyles(widget)) {
        throw new Error("Cannot update style on node that has no style");
    }
    var nextStyles = (0, lodash_1.cloneDeep)(widget.style);
    try {
        for (var newStyles_1 = __values(newStyles), newStyles_1_1 = newStyles_1.next(); !newStyles_1_1.done; newStyles_1_1 = newStyles_1.next()) {
            var _c = newStyles_1_1.value, path_1 = _c.pathToUpdate, value = _c.value;
            (0, lodash_1.set)(nextStyles, path_1, value);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (newStyles_1_1 && !newStyles_1_1.done && (_a = newStyles_1.return)) _a.call(newStyles_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    slate_1.Transforms.setNodes(editor, { style: nextStyles }, { at: path, match: nodeSupportsStyles, mode: "highest" });
};
exports.updateWidgetStyles = updateWidgetStyles;
var clearMatchingOverrides = function (editor, path) {
    var sourceWidgetEntry = slate_2.Editor.node(editor, path);
    if (!slate_1.Element.isElement(sourceWidgetEntry[0])) {
        return;
    }
    var _a = __read(sourceWidgetEntry, 1), sourceElement = _a[0];
    if (!nodeSupportsStyles(sourceElement)) {
        throw new Error("Cannot use a source node that doesn't support styles");
    }
    var styleableConfig = (0, GetTraitConfig_1.getTraitConfig)({ traitName: "styleable", widgetType: sourceElement.type });
    (0, tiny_invariant_1.default)(!!styleableConfig, "Cannot clear overrides for non-styleable widget ".concat(sourceElement.type));
    var nodesThatMightNeedUpdating = slate_2.Editor.nodes(editor, {
        match: function (node) {
            return slate_1.Element.isElement(node) && node.type === sourceElement.type && nodeSupportsStyles(node) && !(0, lodash_1.isEmpty)(node.style);
        },
        voids: true,
        at: [],
    });
    slate_2.Editor.withoutNormalizing(editor, function () {
        var e_2, _a;
        var _loop_1 = function (node) {
            var anyStyleChangeForNode = false;
            var nextNodeStyle = (0, lodash_1.cloneDeep)(node[0].style);
            styleableConfig.properties.forEach(function (property) {
                var sourceValue = (0, lodash_1.get)(sourceElement.style, property.path);
                var destinationValue = (0, lodash_1.get)(nextNodeStyle, property.path);
                if (!!sourceValue &&
                    !!destinationValue &&
                    (0, Styleable_1.styleablePropertiesAreEqual)(sourceValue, destinationValue, property)) {
                    (0, exports.recursivelyUnset)(nextNodeStyle, property.path);
                    anyStyleChangeForNode = true;
                }
            });
            if (anyStyleChangeForNode) {
                slate_1.Transforms.setNodes(editor, { style: nextNodeStyle }, { at: node[1], match: nodeSupportsStyles, mode: "highest" });
            }
        };
        try {
            for (var nodesThatMightNeedUpdating_1 = __values(nodesThatMightNeedUpdating), nodesThatMightNeedUpdating_1_1 = nodesThatMightNeedUpdating_1.next(); !nodesThatMightNeedUpdating_1_1.done; nodesThatMightNeedUpdating_1_1 = nodesThatMightNeedUpdating_1.next()) {
                var node = nodesThatMightNeedUpdating_1_1.value;
                _loop_1(node);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (nodesThatMightNeedUpdating_1_1 && !nodesThatMightNeedUpdating_1_1.done && (_a = nodesThatMightNeedUpdating_1.return)) _a.call(nodesThatMightNeedUpdating_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    });
};
exports.clearMatchingOverrides = clearMatchingOverrides;
var clearWidgetOverrides = function (editor, widgetType) {
    var supportsStyle = (0, Config_types_1.isWidgetType)(widgetType) && !!(0, GetTraitConfig_1.getTraitConfig)({ traitName: "styleable", widgetType: widgetType });
    if (!supportsStyle) {
        throw new Error("Cannot use a widget type that doesn't support styles");
    }
    slate_1.Transforms.setNodes(editor, { style: {} }, {
        match: function (node) {
            return slate_1.Element.isElement(node) && node.type === widgetType && nodeSupportsStyles(node) && !(0, lodash_1.isEmpty)(node.style);
        },
        voids: true,
        at: [],
    });
};
exports.clearWidgetOverrides = clearWidgetOverrides;
var removeElementStyle = function (editor, path, stylePath) {
    var sourceWidgetEntry = slate_2.Editor.node(editor, path);
    if (!slate_1.Element.isElement(sourceWidgetEntry[0])) {
        return;
    }
    var _a = __read(sourceWidgetEntry, 1), sourceElement = _a[0];
    if (!nodeSupportsStyles(sourceElement)) {
        throw new Error("Cannot use a source node that doesn't support styles");
    }
    var nextStyle = (0, lodash_1.cloneDeep)(sourceElement.style);
    (0, exports.recursivelyUnset)(nextStyle, stylePath);
    slate_1.Transforms.setNodes(editor, { style: nextStyle }, { at: path, match: nodeSupportsStyles, mode: "highest" });
};
exports.removeElementStyle = removeElementStyle;
var recursivelyUnset = function (object, path) {
    (0, lodash_1.unset)(object, path);
    var pathSegments = path.split(".");
    if (pathSegments.length === 1) {
        return;
    }
    var parentPathSegments = pathSegments.slice(0, -1);
    var parentPath = parentPathSegments.join(".");
    var parent = (0, lodash_1.get)(object, parentPath);
    if ((0, lodash_1.isEmpty)(parent)) {
        (0, exports.recursivelyUnset)(object, parentPath);
    }
};
exports.recursivelyUnset = recursivelyUnset;
